import React, { useState, useEffect } from "react";
import { Input, Tooltip, Icon } from "@tinper/next-ui";
import hocWithBaseElementWrap from "@utils/hocWithBaseElementWrap";
import { decodeValue, onHandleBordered } from "@utils/index";
import "./style/index.less"
import ReferInput from "../ReferInput";
import { isDesign, getDesignStyle, getFieldId } from '../../utils/tool'

const YbSystemFields = props => {
  const extraProps = props.extraProps || {};
  const {
    // table渲染传递的属性
    onTableFocus = null,
    autoFocus: isFocus,
  } = extraProps;
  let {
    value = "",
    disabled = false,
    readOnly = false,
    visible = true,
    designDomAttr = {}, // 设计器属性
    designDomClassName = "", // 设计器class
    alias,
    renderEnv,
    systemField,
    cStyle,
    maxLength = 16,
    className = "",
    regRuleText,
    // controlType,
  } = props;
  
  /* —————————————————————— value显示 —————————————————————— */
  if (!isDesign(renderEnv)) {
    return <ReferInput {...props} ></ReferInput>;
  }
  /* —————————————————————— value显示 —————————————————————— */
  /* —————————————————————— 编辑状态 —————————————————————— */
  try {
    cStyle = JSON.parse(cStyle);
  } catch (err) {}
  // const defShowValue = "";
  const [value$, setValue$] = useState(value);
  const [checkErrorStatus, setCheckErrorStatus] = useState(false);
  const [helpTips, setHelpTips] = useState("");
  const [showTips, setShowTips] = useState(false);

  let designStyle = {};
  if (isDesign(renderEnv)) {
    designStyle = { pointerEvents: "none" };
  }

  useEffect(() => {
    if (value !== value$) setValue$(value);
  }, [value]);

  /**
   * 输入框获取焦点触发的事件
   * @param {*} val
   */
  const handleBlur = val => {
    onTableFocus?.("blur");
    const errormsg = validateReg(val);
    if (errormsg !== "") {
      setCheckErrorStatus(true);
      setHelpTips(errormsg);
      props?.onError?.(val);
    } else {
      setCheckErrorStatus(false);
      setHelpTips("");
      autoFocus && props?.onChange?.(val);
    }
  };

  const handleChange = val => {
    setValue$(val);
    // onTableFocus == null && props?.onChange?.(val);
  };

  /**
   * 校验输入的内容是否正确
   * @param {*} value
   * @returns
   */
  const validateReg = value => {
    let checkErrMsg = "";
      if (!value) {
        checkErrMsg = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A20B5605A80014', '输入错误');
      }
    return checkErrMsg;
  };

  const val = !alias.startsWith("NocSystemFields") ? "--" : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D005D00015', '未设置系统字段');
  className = className ? className + " yb-system-field" : "yb-system-field"
  const getFieldId = () => {
    const { fieldid, fieldidPrefix } = props || {};
    return fieldid || fieldidPrefix;
  };
  // 获取样式的选择，如果是默认样式就传true，如果是下划线样式就传bottom，使用的input组件规定参数这么写才生效
  return visible ? (
    <Tooltip
      fieldid={`${getFieldId()}`}
      color={"#ffffff"}
      arrowPointAtCenter
      placement="top"
      getPopupContainer={triggerNode => triggerNode.parentNode}
      overlay={<span style={{ color: "#f44336", fontWeight: "bold" }}>{helpTips}</span>}
      visible={showTips}>
        <span style={{ ...cStyle, ...designStyle }}
          onBlur={handleBlur}
          fieldid={`${getFieldId()}`}
          onMouseEnter={() => {
            if (helpTips !== "") {
              setShowTips(true);
            }
          }}
          onMouseLeave={() => {
            setShowTips(false);
          }}
          className={className}
          {...designDomAttr}
          designDomClassName={designDomClassName}
        >{val}</span>
    </Tooltip>
  ) : (
    <span></span>
  );
};

export default hocWithBaseElementWrap(YbSystemFields);
